import features from '~/constants/features';
import paths from '~/pages/paths';
import { isAgent, isSales } from './getDecodedJwt';
import createUid from './createUid';

const getUtmParams = (urlParams: URLSearchParams) => ({
  utm_source: urlParams.get('utm_source') ?? '',
  utm_campaign: urlParams.get('utm_campaign') ?? '',
  utm_medium: urlParams.get('utm_medium') ?? '',
  utm_content: urlParams.get('utm_content') ?? '',
  utm_term: urlParams.get('utm_term') ?? '',
});

const buildNGeniusUrl = (utmParams: ReturnType<typeof getUtmParams>, trackingId: string) => {
  const params = new URLSearchParams({ ...utmParams, tracking_id: trackingId });
  return `/ngenius-portalsob/?${params.toString()}`;
};

const buildNGeniusUrlSignup = (utmParams: ReturnType<typeof getUtmParams>, trackingId: string) => {
  const params = new URLSearchParams({ ...utmParams, tracking_id: trackingId });
  return `/ngenius-portalsob-signup/?${params.toString()}`;
};

export const redirectToExternalAuth = () => {
  const currentPath = window.location.pathname;
  const urlParams = new URLSearchParams(window.location.search);
  const trackingId = createUid();
  localStorage.setItem('tracking_id', trackingId);

  if (
    currentPath.startsWith(paths.agent._) ||
    currentPath.startsWith(paths.redirect.application) ||
    isAgent() ||
    isSales()
  ) {
    if (
      currentPath !== paths.auth.agentAuthCallback &&
      currentPath !== paths.auth.redirectAgentToKeyCloak
    ) {
      window.location.replace(
        `${paths.auth.redirectAgentToKeyCloak}?tenantId=${features.tenantId}`
      );
    }
  } else if (
    currentPath !== paths.auth.merchantAuthCallback &&
    currentPath !== paths.auth.redirectToKeyCloak
  ) {
    const isLocalhost = window.location.hostname === 'localhost';
    if (isLocalhost) {
      window.location.replace(`${paths.auth.redirectToKeyCloak}?tenantId=${features.tenantId}`);
    } else if (
      Object.entries(getUtmParams(urlParams) || {})?.some(([, value]: [string, unknown]) =>
        Boolean(value)
      ) ||
      urlParams.get('channels') === 'NI_WEBSITE'
    ) {
      console.log('Have UTMs', getUtmParams(urlParams));
      window.location.replace(buildNGeniusUrlSignup(getUtmParams(urlParams), trackingId));
    } else {
      window.location.replace(buildNGeniusUrl(getUtmParams(urlParams), trackingId));
    }
  }
};

export const redirectAfterVerification = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const urlTrackingId = urlParams.get('tracking_id') || '';
  const localTrackingId = localStorage.getItem('tracking_id');

  if (urlTrackingId !== localTrackingId) {
    localStorage.setItem('tracking_id', urlTrackingId);
    // different browser fire up some actions
  }
  console.log('Redirected');
  window.location.replace(buildNGeniusUrl(getUtmParams(urlParams), urlTrackingId));
};
